// src/pages/EstacionesList.js
import React, { useState, useEffect, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { fetchUsers, fetchUserDetails } from '../services/apiService';
import UserEstacionesList from '../components/UserEstacionesList';
import menuItemsByService from '../categories/serviceMenus';
import { useSidebar } from '../context/SidebarContext';

const EstacionesList = () => {
  const { authTokens, impersonateUser, impersonatedUserId } = useContext(AuthContext);
  const [users, setUsers] = useState([]);
  const { isSidebarOpen } = useSidebar();
  const [userServices, setUserServices] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const loadData = async () => {
      const fetchedUsers = await fetchUsers(authTokens);
      setUsers(fetchedUsers);
    };

    loadData();
  }, [authTokens]);

  useEffect(() => {
    const loadUserServices = async () => {
      if (authTokens && (impersonatedUserId || authTokens.userRole !== 'admin')) {
        try {
          const userIdToFetch = impersonatedUserId || authTokens.userId;
          const userDetails = await fetchUserDetails(userIdToFetch, authTokens);
          const serviceOrder = {
            'Anexo 30 y 31 2022': 1,
            'Anexo 30 y 31 2023': 2,
            'Anexo 30 y 31 2024': 3,
            'Anexo 30 y 31 2025': 4,
            'Dictamen de Diseño': 5,
            'NOM-016-CRE-2016': 6,
            'Anexo 30 y 31 para transporte o distribución': 7,
          };
          const sortedServices = userDetails.services.sort(
            (a, b) => (serviceOrder[a.name] || 0) - (serviceOrder[b.name] || 0),
          );
          setUserServices(sortedServices);
        } catch (error) {
          console.error('Error al cargar los servicios del usuario:', error);
        }
      }
    };

    loadUserServices();
  }, [authTokens, impersonatedUserId]);

  const handleImpersonate = (userId) => {
    impersonateUser(userId);
    navigate('/dashboard');
  };

  if (!authTokens) {
    return <div>Cargando...</div>;
  }

  return (
    <div className="flex min-h-screen bg-gray-100">
      {/* Sidebar */}
      <div
        className={`fixed md:fixed top-16 left-0 h-[calc(100vh-4rem)] overflow-y-auto transform
          ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'}
          transition duration-200 ease-in-out
          w-64 bg-white shadow-lg z-40`}
      >
        <div className="p-8 border-b">
          <img src="/images/logo2.png" alt="Logo Petrotec" className="h-32 w-auto mx-auto" />
        </div>
        <nav className="mt-6">
          <Link
            to="/dashboard"
            className={`
              block px-4 py-3 hover:bg-blue-50 transition-colors duration-200
              text-gray-700 hover:text-blue-600 border-b border-gray-100
            `}
          >
            Inicio
          </Link>
          <div className="px-4 py-2">
            <h2 className="text-xs uppercase font-semibold text-gray-600 tracking-wide">
              Servicios Disponibles
            </h2>
          </div>
          {userServices.map((service) => {
            const firstMenuItem = menuItemsByService[service.name]?.[0];
            return (
              <Link
                key={service.id}
                to={firstMenuItem?.path || '#'}
                className="block px-4 py-3 hover:bg-blue-50 transition-colors duration-200 text-gray-700 hover:text-blue-600"
              >
                {service.name}
              </Link>
            );
          })}
        </nav>
      </div>

      {/* Main Content */}
      <div className={`flex-1 transition-all duration-200 ${isSidebarOpen ? 'md:ml-64' : ''}`}>

        <div className="p-8">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900">Lista de Estaciones</h1>
            <p className="mt-2 text-gray-600">Gestiona y accede a las estaciones registradas en el sistema.</p>
          </div>

          <div className="bg-white shadow-lg rounded-lg">
            <UserEstacionesList
              title="Estaciones"
              users={users.filter((user) => user.role === 'user')}
              onImpersonate={handleImpersonate}
              authTokens={authTokens}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EstacionesList;
